module.exports = __webpack_public_path__ + "media/application/images/ui/bronze-member-211e30837b100c9d77012b4f9915e879.png";